import { Admin_URL } from '@/helpers/URL'

const AdminControllerEndpoint = path => {
  if (!path) {
    throw new Error('Path is required')
  }
  return `${Admin_URL}${path}`
}

// POST Endpoints
export const UPDATE_LOCATION = AdminControllerEndpoint('updateLocation')
export const UPDATE_APPL_PARAMETER = AdminControllerEndpoint('updateApplParameter')
export const ADD_LOCAITON = AdminControllerEndpoint('addLocation')
export const ADD_APPL_PARAMETER = AdminControllerEndpoint('addApplParameter')

//GET Endpoints
export const GET_ALL_LOCATIONS = AdminControllerEndpoint('getAllLocations')
export const GET_ALL_APPL_PARAMETERS_1 = AdminControllerEndpoint('getAllApplParameters')
